import { http } from 'cdui-js';

export function fetchConfig() {
  return http.get(`/sys/dict/configurations`);
}

export function fetchCountry() {
  return http.get(`/sys/dict/country`);
}

export function fetchBusConfigs() {
  return http.get(`/sys/dict/busConfigs`);
}

// NORMAL("normal", "普通文件"),
// IDENTITY_FRONT("identity_front", "身份证正面"),
// IDENTITY_BACK("identity_back", "身份证反面"),
// HONGKONG_IDENTITY("hongkong_identity", "香港身份证"),
// MACAO_IDENTITY("macao_identity", "澳门身份证"),
// PASSPORT("passport", "护照"),
// ADDRESS_PROVE("address_prove", "地址证明"),
// TRANSFER_PROVE("transfer_prove", "转账证明");
// BANK_PROVE("bank_prove", "银行证明"),
// SIGNATURE_STICKER("signature_sticker", "开户贴图签名图（非大陆延迟贴图）"),
/**
 * 敏感件私有上传（开户/绑卡/入金等），服务端强制加密落盘。
 */
function resolveUploadFileName(file: Blob | File | null | undefined): string {
  if (file instanceof File && file.name && file.name !== 'blob') {
    return file.name;
  }
  if (file?.type === 'application/pdf') return 'document.pdf';
  if (file?.type === 'image/png') return 'image.png';
  if (file?.type === 'image/webp') return 'image.webp';
  return 'image.jpg';
}

export async function uploadFile({ useFor = 'identity', file, busId, isOCR }) {
  const formData = new FormData();
  // 第三参显式传 filename，避免 Blob / name=blob 时落到 filename="blob" 被后端拒收
  formData.append('file', file, resolveUploadFileName(file));
  formData.append('useFor', useFor);
  formData.append('busId', busId);
  formData.append('isOCR', isOCR ? 'true' : 'false');

  // Authorization 由 http-interceptor 注入（App 开户 session / 活动 session / H5 localStorage）
  const data = (await http.send(`/api/v1/file/upload/private`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return data;
}

/*
 * 用途：公共明文上传（头像、反馈等）
 * @param file 文件
 * @param useFor 使用目的
 * @param busId 业务id,可用用户ID
 * @returns 文件信息
 */
export async function uploadCommonFile(_file: File | null, useFor?: string, busId?: string) {
  const formData = new FormData();
  if (_file) {
    formData.append('file', _file, resolveUploadFileName(_file));
  }
  if (useFor) {
    formData.append('useFor', useFor);
  }
  if (busId) {
    formData.append('busId', busId);
  }

  // Authorization 由 http-interceptor 注入（App 开户 session / 活动 session / H5 localStorage）
  const data = (await http.send(`/api/v1/file/upload`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return data;
}
